module.exports = __webpack_public_path__ + "img/PICC.2f4c421e.jpg";